module.exports = __webpack_public_path__ + "img/idle-dj-details1.dd9422e0.png";